import React, { ReactElement } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";
import { DropsButton } from "shared/components/Spor";
import styled, { css } from "styled-components";

export type ActionButton = {
  title: string;
  disabled?: boolean;
  onClick: () => void;
  leftIcon?: ReactElement;
  rightIcon?: ReactElement;
  loading?: boolean;
  variant?: "primary" | "tertiary";
};

const ActionGroup = styled.div<{ $rightAlign: boolean }>`
  gap: 6px;

  width: 100%;

  ${({ $rightAlign }) =>
    $rightAlign
      ? css`
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-end;
        `
      : css`
          display: grid;
          grid-template-columns: repeat(2, auto) 1fr;
        `}
`;

interface ActionButtonsProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  actionButtons: ActionButton[];
  semantics: Semantics;
  rightAlign?: boolean;
}

export const ActionButtons = ({
  actionButtons,
  semantics,
  rightAlign = false,
  ...rest
}: ActionButtonsProps) => (
  <ActionGroup $rightAlign={rightAlign} role="group" {...rest}>
    {actionButtons.map((button) => (
      <DropsButton
        semantics={semantics}
        key={button.title}
        size="xs"
        variant={button.variant}
        disabled={button.disabled}
        loading={button.loading}
        onClick={button.onClick}
        leftIcon={button.leftIcon}
        rightIcon={button.rightIcon}
      >
        {button.title}
      </DropsButton>
    ))}
  </ActionGroup>
);
